module.exports = __webpack_public_path__ + "img/数据分析.e25a8216.svg";